export const CRM_DETAIL_SUBPAGES = [
  "overview",
  "reservations",
  "activity",
  "tasks",
  "notes",
  "events",
];

export const normalizeCrmSubpage = (subpage) =>
  CRM_DETAIL_SUBPAGES.includes(subpage) ? subpage : "overview";

export const buildCrmDetailPath = (categorySlug, shareId, subpage) => {
  const basePath = `/crm/${categorySlug || "owners"}`;
  if (!shareId) return basePath;
  return `${basePath}/${shareId}/${normalizeCrmSubpage(subpage)}`;
};
